const allowedEmails = new Set([
  "mmoiloa@dgt.ictsi.com",
  "hnaidoo@dgt.ictsi.com",
  "angcobo@dgt.ictsi.com",
  "jmthembu@dgt.ictsi.com",
  "lbuthelezi@dgt.ictsi.com",
  "sdlamini3@dgt.ictsi.com",
  "nsibeko@dgt.ictsi.com",
]);
export default allowedEmails;